// Text catalog for the Viden section (ordbog listing + term detail pages).
// The route only exists in Danish for now; en/de are ready for the rollout.

import { type Locale } from "../config";
import { type PageMeta } from "../head";

type VidenStrings = {
  meta: PageMeta;
  hero: { eyebrow: string; title: string; intro: string };
  jumpLabel: string;
  termEyebrow: string;
  termMetaTitle: (term: string) => string;
  backToList: string;
  relatedHeading: string;
  cta: { heading: string; body: string; button: string };
};

const da: VidenStrings = {
  meta: {
    title: "Ordbog: Begreber i bygge- og projektledelse | MI Support",
    description:
      "Bliv klogere på centrale begreber i bygge-, projekt- og sikkerhedsledelse. Korte, præcise forklaringer skrevet af konsulenterne bag de store projekter.",
  },
  hero: {
    eyebrow: "Viden",
    title: "Ordbog",
    intro:
      "Bliv klogere på centrale begreber inden for bygge-, projekt- og sikkerhedsledelse. Korte, præcise forklaringer på dansk – skrevet af konsulenterne bag de store projekter.",
  },
  jumpLabel: "Hop til bogstav",
  termEyebrow: "Viden · Ordbog",
  termMetaTitle: (term) => `Hvad er ${term}? | MI Support Ordbog`,
  backToList: "Tilbage til ordbogen",
  relatedHeading: "Læs mere",
  cta: {
    heading: "Skal vi tage en snak om jeres projekt?",
    body: "Har I spørgsmål til et begreb – eller brug for en konsulent, der behersker det i praksis? Vi står klar til at hjælpe.",
    button: "Kontakt os",
  },
};

const en: VidenStrings = {
  meta: {
    title: "Knowledge – Glossary of construction and project management terms | MI Support",
    description:
      "Learn the key terms in construction, project and safety management. Short, precise explanations written by the consultants behind major projects.",
  },
  hero: {
    eyebrow: "Knowledge",
    title: "Glossary",
    intro:
      "Learn the key terms in construction, project and safety management. Short, precise explanations written by the consultants behind major projects.",
  },
  jumpLabel: "Jump to letter",
  termEyebrow: "Knowledge · Glossary",
  termMetaTitle: (term) => `What is ${term}? | MI Support Glossary`,
  backToList: "Back to the glossary",
  relatedHeading: "Read more",
  cta: {
    heading: "Shall we talk about your project?",
    body: "Questions about a term – or need a consultant who masters it in practice? We're ready to help.",
    button: "Contact us",
  },
};

const de: VidenStrings = {
  meta: {
    title: "Wissen – Glossar der Begriffe aus Bau- und Projektmanagement | MI Support",
    description:
      "Lernen Sie die zentralen Begriffe aus Bau-, Projekt- und Sicherheitsmanagement kennen. Kurze, präzise Erklärungen von den Beratern hinter den großen Projekten.",
  },
  hero: {
    eyebrow: "Wissen",
    title: "Glossar",
    intro:
      "Lernen Sie die zentralen Begriffe aus Bau-, Projekt- und Sicherheitsmanagement kennen. Kurze, präzise Erklärungen von den Beratern hinter den großen Projekten.",
  },
  jumpLabel: "Zum Buchstaben springen",
  termEyebrow: "Wissen · Glossar",
  termMetaTitle: (term) => `Was ist ${term}? | MI Support Glossar`,
  backToList: "Zurück zum Glossar",
  relatedHeading: "Mehr erfahren",
  cta: {
    heading: "Sollen wir über Ihr Projekt sprechen?",
    body: "Fragen zu einem Begriff – oder Bedarf an einem Berater, der ihn in der Praxis beherrscht? Wir helfen Ihnen gerne.",
    button: "Kontaktieren Sie uns",
  },
};

export const videnStrings: Record<Locale, VidenStrings> = { da, en, de };
